@use "variables" as *;

.container {
  position: relative;
  width: 100%;
  display: flex;
  .hoverButtonsStack {
    visibility: hidden;
    position: absolute;
    right: $spacing-m;
    top: 0;
    bottom: 0;
    margin: auto 0;
    align-items: center;
  }
  &:hover .hoverButtonsStack {
    visibility: visible;
  }
}

.hoverButton {
  width: 24px;
  height: 24px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}

.hoverButtonIcon {
  font-size: $fontSize-l !important;
}

.quantity {
  width: 40px;
  font-size: $fontSize-s;
  font-weight: normal;
  text-align: center;
  flex-shrink: 0;
  font-variant: tabular-nums;
}

.name {
  font-size: $fontSize-s;
  font-weight: normal;
}

.description {
  font-size: $fontSize-xs;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.playbackSpeed {
  width: 64px;
  font-size: $fontSize-xs;
  font-weight: normal;
  text-align: left;
  flex-shrink: 0;
  font-variant: tabular-nums;
}

.color {
  width: 80px;
  font-size: $fontSize-xs;
  font-weight: normal;
  text-align: left;
  flex-shrink: 0;
  font-variant: tabular-nums;
}
